import React from "react";
import { Card, Popconfirm, message, Row, Col, Spin, Empty } from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { EditOutlined, DeleteFilled } from "@ant-design/icons";
// import cookie from "react-cookies";

const Faq = () => {
  const [allblog, setAllBlog] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const navigate = useNavigate();
  const { Meta } = Card;

  //method for API call
  const getFaqHandler = () => {
    setLoader(true);
    //axios call
    axios
      .get(`${process.env.REACT_APP_FRONTED_URL}/blogs?domain=Gng`)
      .then((response) => {
        setAllBlog(response?.data);
        setLoader(false);
      })
      .catch((error) => {
        message.error("Error", error?.response?.data?.message);
        setLoader(false);
      });
  };
  //  API for Faq
  useEffect(() => {
    getFaqHandler();
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    axios
      .delete(`${process.env.REACT_APP_FRONTED_URL}/blogs/${data?._id}`)
      .then(() => {
        // to delete locally from our database
        const remaingRecords = allblog?.blogs?.filter(
          (item) => item?._id !== data?._id
        );
        setAllBlog({ ...allblog, blogs: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch((error) => {
        message.error("Error", error?.response?.data?.message);
        setSelectedRecord(false);
      });
  };

  const cancel = (e) => {
    console.log(e);
  };

  return (
    <React.Fragment>
      <div className="header">
        <h3>GNG Blogs</h3>
        <Link to="/add-gng-blog">
          <button className="cursor-pointer">Add Blog</button>
        </Link>
      </div>
      {/* Duomo Blog Loader */}
      {loader ? (
        <div className="spin_information">
          <Spin />
        </div>
      ) : allblog?.blogs?.length > 0 ? (
        <div>
          <div className="faq_content">
            <div>
              <Row gutter={24} scroll={{ x: 1023 }}>
                {allblog?.blogs?.map((data, index) => (
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={6}
                    xxl={8}
                    key={index}
                  >
                    <Card
                      cover={
                        <img
                          alt="image"
                          src={
                            data?.image
                              ? data?.image
                              : "https://placehold.co/530x300?text=530x300&font=roboto"
                          }
                          className="card-img-height"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://placehold.co/530x300?text=530x300&font=roboto";
                          }}
                        />
                      }
                      actions={[
                        <EditOutlined
                          key="edit"
                          className="delete-icon-admin cursor-pointer "
                          onClick={() =>
                            navigate("/edit-gng-blog/" + data?._id)
                          }
                        />,
                        data?._id === selectedRecord ? (
                          <Spin />
                        ) : (
                          <Popconfirm
                            title="Delete the Project"
                            description="Are you sure to delete this Project?"
                            onConfirm={() => confirm(data)}
                            onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                          >
                            <DeleteFilled className="delete-icon-admin cursor-pointer" />
                          </Popconfirm>
                        ),
                      ]}
                    >
                      <Meta
                        title={
                          <div className="truncate-title-one">
                            {data?.title}
                          </div>
                        }
                        description={
                          <div className="truncate-title-one">
                            {data?.shortDescription}
                          </div>
                        }
                        className="margin-bottom-card"
                      />
                    </Card>
                  </Col>
                ))}
              </Row>

              {/* <Pagination
                defaultCurrent={1}
                total={50}
                className="pagination"
              /> */}
            </div>
          </div>
        </div>
      ) : (
        <div className="no-data">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            className="spin-center2"
          />
        </div>
      )}
    </React.Fragment>
  );
};
export default Faq;
